// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

import ServiceLinkClientBase from "./serviceLinkClient.base";

/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IServiceLinkClient {
  /**
   * Gets a proposal by its Id
   * @return OK
   */
  apiV1Proposal(id: string): Promise<ProposalResponse>;

  /**
   * Gets a full length list of proposals
   * @param body (optional)
   * @return OK
   */
  apiV1ProposalList(
    body: ListProposalsRequest | undefined
  ): Promise<ProposalResponse[]>;

  /**
   * Creates an empty proposal with the minimum required props
   * @param body (optional)
   * @return OK
   */
  apiV1ProposalCreate(body: CreateProposalRequest | undefined): Promise<string>;

  /**
   * Updates the proposal with the provided information
   * @param body (optional)
   * @return OK
   */
  apiV1ProposalUpdate(body: UpdateProposalRequest | undefined): Promise<void>;

  /**
   * Sends the vbo proposal and updates its status to sent.
   * @param body (optional)
   * @return OK
   */
  apiV1ProposalSend(body: SendProposalRequest | undefined): Promise<void>;

  /**
   * Mark the proposal as opened by customer.
   * @param body (optional)
   * @return OK
   */
  apiV1ProposalOpenedByCustomer(body: string | undefined): Promise<void>;

  /**
   * The customer should report back what items the customer accepted.
   * @param body (optional)
   * @return OK
   */
  apiV1ProposalRespond(
    body: CustomerResponseRequest | undefined
  ): Promise<void>;

  /**
   * Get all available priorities for proposals.
   * @param accept_Language (optional)
   * @return OK
   */
  apiV1ProposalPrioritiesAll(
    accept_Language: string | undefined
  ): Promise<PriorityResponse[]>;

  /**
   * Upload a file from a form
   * @param type (optional)
   * @param files (optional)
   * @return OK
   */
  apiUploadCreate(
    type: ProposalMediaTypeEnum | undefined,
    files: FileParameter[] | undefined
  ): Promise<string[]>;

  /**
   * Delete a file from storage
   * @param type (optional)
   * @return OK
   */
  apiUploadDelete(
    id: string,
    type: ProposalMediaTypeEnum | undefined
  ): Promise<string>;

  /**
   * Gets a file from storage
   * @param type (optional)
   * @return OK
   */
  apiUploadGet(
    id: string,
    type: ProposalMediaTypeEnum | undefined
  ): Promise<FileResponse>;
}

export class ServiceLinkClient
  extends ServiceLinkClientBase
  implements IServiceLinkClient
{
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  /**
   * Gets a proposal by its Id
   * @return OK
   */
  apiV1Proposal(id: string): Promise<ProposalResponse> {
    let url_ = this.baseUrl + "/api/v1/proposal/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV1Proposal(_response);
    });
  }

  protected processApiV1Proposal(
    response: Response
  ): Promise<ProposalResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ProposalResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProposalResponse>(null as any);
  }

  /**
   * Gets a full length list of proposals
   * @param body (optional)
   * @return OK
   */
  apiV1ProposalList(
    body: ListProposalsRequest | undefined
  ): Promise<ProposalResponse[]> {
    let url_ = this.baseUrl + "/api/v1/proposal/list";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV1ProposalList(_response);
    });
  }

  protected processApiV1ProposalList(
    response: Response
  ): Promise<ProposalResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(ProposalResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProposalResponse[]>(null as any);
  }

  /**
   * Creates an empty proposal with the minimum required props
   * @param body (optional)
   * @return OK
   */
  apiV1ProposalCreate(
    body: CreateProposalRequest | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/proposal/create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV1ProposalCreate(_response);
    });
  }

  protected processApiV1ProposalCreate(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Updates the proposal with the provided information
   * @param body (optional)
   * @return OK
   */
  apiV1ProposalUpdate(body: UpdateProposalRequest | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/proposal/update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV1ProposalUpdate(_response);
    });
  }

  protected processApiV1ProposalUpdate(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Sends the vbo proposal and updates its status to sent.
   * @param body (optional)
   * @return OK
   */
  apiV1ProposalSend(body: SendProposalRequest | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/proposal/send";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV1ProposalSend(_response);
    });
  }

  protected processApiV1ProposalSend(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Mark the proposal as opened by customer.
   * @param body (optional)
   * @return OK
   */
  apiV1ProposalOpenedByCustomer(body: string | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/proposal/opened-by-customer";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV1ProposalOpenedByCustomer(_response);
    });
  }

  protected processApiV1ProposalOpenedByCustomer(
    response: Response
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * The customer should report back what items the customer accepted.
   * @param body (optional)
   * @return OK
   */
  apiV1ProposalRespond(
    body: CustomerResponseRequest | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/proposal/respond";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV1ProposalRespond(_response);
    });
  }

  protected processApiV1ProposalRespond(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Get all available priorities for proposals.
   * @param accept_Language (optional)
   * @return OK
   */
  apiV1ProposalPrioritiesAll(
    accept_Language: string | undefined
  ): Promise<PriorityResponse[]> {
    let url_ = this.baseUrl + "/api/v1/proposal/priorities/all";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        "Accept-Language":
          accept_Language !== undefined && accept_Language !== null
            ? "" + accept_Language
            : "",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV1ProposalPrioritiesAll(_response);
    });
  }

  protected processApiV1ProposalPrioritiesAll(
    response: Response
  ): Promise<PriorityResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PriorityResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PriorityResponse[]>(null as any);
  }

  /**
   * Upload a file from a form
   * @param type (optional)
   * @param files (optional)
   * @return OK
   */
  apiUploadCreate(
    type: ProposalMediaTypeEnum | undefined,
    files: FileParameter[] | undefined
  ): Promise<string[]> {
    let url_ = this.baseUrl + "/api/upload/create?";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      url_ += "type=" + encodeURIComponent("" + type) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (files === null || files === undefined)
      throw new Error("The parameter 'files' cannot be null.");
    else
      files.forEach((item_) =>
        content_.append(
          "files",
          item_.data,
          item_.fileName ? item_.fileName : "files"
        )
      );

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiUploadCreate(_response);
    });
  }

  protected processApiUploadCreate(response: Response): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(item);
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status === 415) {
      return response.text().then((_responseText) => {
        let result415: any = null;
        let resultData415 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result415 = ProblemDetails.fromJS(resultData415);
        return throwException(
          "Unsupported Media Type",
          status,
          _responseText,
          _headers,
          result415
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string[]>(null as any);
  }

  /**
   * Delete a file from storage
   * @param type (optional)
   * @return OK
   */
  apiUploadDelete(
    id: string,
    type: ProposalMediaTypeEnum | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/upload/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      url_ += "type=" + encodeURIComponent("" + type) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiUploadDelete(_response);
    });
  }

  protected processApiUploadDelete(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Gets a file from storage
   * @param type (optional)
   * @return OK
   */
  apiUploadGet(
    id: string,
    type: ProposalMediaTypeEnum | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/upload/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      url_ += "type=" + encodeURIComponent("" + type) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiUploadGet(_response);
    });
  }

  protected processApiUploadGet(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export enum BrandCodeEnum {
  A = "A",
  V = "V",
  S = "S",
  C = "C",
  N = "N",
  P = "P",
}

export class CreateProposalRequest implements ICreateProposalRequest {
  createdBy!: string;
  dealer!: string;
  workOrderId?: string | undefined;
  chassiNumber!: string;
  registrationNumber!: string;
  modelText!: string;
  brand!: BrandCodeEnum;

  constructor(data?: ICreateProposalRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.createdBy = _data["createdBy"];
      this.dealer = _data["dealer"];
      this.workOrderId = _data["workOrderId"];
      this.chassiNumber = _data["chassiNumber"];
      this.registrationNumber = _data["registrationNumber"];
      this.modelText = _data["modelText"];
      this.brand = _data["brand"];
    }
  }

  static fromJS(data: any): CreateProposalRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateProposalRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["createdBy"] = this.createdBy;
    data["dealer"] = this.dealer;
    data["workOrderId"] = this.workOrderId;
    data["chassiNumber"] = this.chassiNumber;
    data["registrationNumber"] = this.registrationNumber;
    data["modelText"] = this.modelText;
    data["brand"] = this.brand;
    return data;
  }
}

export interface ICreateProposalRequest {
  createdBy: string;
  dealer: string;
  workOrderId?: string | undefined;
  chassiNumber: string;
  registrationNumber: string;
  modelText: string;
  brand: BrandCodeEnum;
}

export class CustomerResponseRequest implements ICustomerResponseRequest {
  proposalId!: string;
  acceptedItemIds!: number[];

  constructor(data?: ICustomerResponseRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.acceptedItemIds = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.proposalId = _data["proposalId"];
      if (Array.isArray(_data["acceptedItemIds"])) {
        this.acceptedItemIds = [] as any;
        for (let item of _data["acceptedItemIds"])
          this.acceptedItemIds!.push(item);
      }
    }
  }

  static fromJS(data: any): CustomerResponseRequest {
    data = typeof data === "object" ? data : {};
    let result = new CustomerResponseRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["proposalId"] = this.proposalId;
    if (Array.isArray(this.acceptedItemIds)) {
      data["acceptedItemIds"] = [];
      for (let item of this.acceptedItemIds) data["acceptedItemIds"].push(item);
    }
    return data;
  }
}

export interface ICustomerResponseRequest {
  proposalId: string;
  acceptedItemIds: number[];
}

export class ListProposalsRequest implements IListProposalsRequest {
  dealer!: string;
  statuses?: ProposalStatusEnum[] | undefined;
  status?: ProposalStatusEnum;

  constructor(data?: IListProposalsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dealer = _data["dealer"];
      if (Array.isArray(_data["statuses"])) {
        this.statuses = [] as any;
        for (let item of _data["statuses"]) this.statuses!.push(item);
      }
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): ListProposalsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ListProposalsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dealer"] = this.dealer;
    if (Array.isArray(this.statuses)) {
      data["statuses"] = [];
      for (let item of this.statuses) data["statuses"].push(item);
    }
    data["status"] = this.status;
    return data;
  }
}

export interface IListProposalsRequest {
  dealer: string;
  statuses?: ProposalStatusEnum[] | undefined;
  status?: ProposalStatusEnum;
}

export class PriorityResponse implements IPriorityResponse {
  id!: number;
  name!: string | undefined;
  value!: number;
  description!: string | undefined;

  constructor(data?: IPriorityResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.value = _data["value"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): PriorityResponse {
    data = typeof data === "object" ? data : {};
    let result = new PriorityResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["value"] = this.value;
    data["description"] = this.description;
    return data;
  }
}

export interface IPriorityResponse {
  id: number;
  name: string | undefined;
  value: number;
  description: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class ProposalCustomerRequest implements IProposalCustomerRequest {
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;

  constructor(data?: IProposalCustomerRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.phone = _data["phone"];
      this.email = _data["email"];
    }
  }

  static fromJS(data: any): ProposalCustomerRequest {
    data = typeof data === "object" ? data : {};
    let result = new ProposalCustomerRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["phone"] = this.phone;
    data["email"] = this.email;
    return data;
  }
}

export interface IProposalCustomerRequest {
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
}

export class ProposalCustomerResponse implements IProposalCustomerResponse {
  firstName!: string;
  lastName!: string;
  phone?: string | undefined;
  email?: string | undefined;

  constructor(data?: IProposalCustomerResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.phone = _data["phone"];
      this.email = _data["email"];
    }
  }

  static fromJS(data: any): ProposalCustomerResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalCustomerResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["phone"] = this.phone;
    data["email"] = this.email;
    return data;
  }
}

export interface IProposalCustomerResponse {
  firstName: string;
  lastName: string;
  phone?: string | undefined;
  email?: string | undefined;
}

export class ProposalItemRequest implements IProposalItemRequest {
  id?: number;
  name?: string | undefined;
  description?: string | undefined;
  priorityId?: number | undefined;
  price?: number;
  requiredTime?: number;
  packages?: ProposalMediaPackageRequest[] | undefined;
  medias?: ProposalMediaRequest[] | undefined;
  customerAccepted?: boolean | undefined;

  constructor(data?: IProposalItemRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.priorityId = _data["priorityId"];
      this.price = _data["price"];
      this.requiredTime = _data["requiredTime"];
      if (Array.isArray(_data["packages"])) {
        this.packages = [] as any;
        for (let item of _data["packages"])
          this.packages!.push(ProposalMediaPackageRequest.fromJS(item));
      }
      if (Array.isArray(_data["medias"])) {
        this.medias = [] as any;
        for (let item of _data["medias"])
          this.medias!.push(ProposalMediaRequest.fromJS(item));
      }
      this.customerAccepted = _data["customerAccepted"];
    }
  }

  static fromJS(data: any): ProposalItemRequest {
    data = typeof data === "object" ? data : {};
    let result = new ProposalItemRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    data["priorityId"] = this.priorityId;
    data["price"] = this.price;
    data["requiredTime"] = this.requiredTime;
    if (Array.isArray(this.packages)) {
      data["packages"] = [];
      for (let item of this.packages) data["packages"].push(item.toJSON());
    }
    if (Array.isArray(this.medias)) {
      data["medias"] = [];
      for (let item of this.medias) data["medias"].push(item.toJSON());
    }
    data["customerAccepted"] = this.customerAccepted;
    return data;
  }
}

export interface IProposalItemRequest {
  id?: number;
  name?: string | undefined;
  description?: string | undefined;
  priorityId?: number | undefined;
  price?: number;
  requiredTime?: number;
  packages?: ProposalMediaPackageRequest[] | undefined;
  medias?: ProposalMediaRequest[] | undefined;
  customerAccepted?: boolean | undefined;
}

export class ProposalItemResponse implements IProposalItemResponse {
  id!: number;
  name?: string | undefined;
  description?: string | undefined;
  priorityId?: number | undefined;
  price!: number;
  requiredTime!: number;
  latestResponseTime?: Date | undefined;
  packages!: ProposalMediaPackageResponse[];
  medias!: ProposalMediaResponse[];
  customerAccepted?: boolean | undefined;

  constructor(data?: IProposalItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.packages = [];
      this.medias = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.priorityId = _data["priorityId"];
      this.price = _data["price"];
      this.requiredTime = _data["requiredTime"];
      this.latestResponseTime = _data["latestResponseTime"]
        ? new Date(_data["latestResponseTime"].toString())
        : <any>undefined;
      if (Array.isArray(_data["packages"])) {
        this.packages = [] as any;
        for (let item of _data["packages"])
          this.packages!.push(ProposalMediaPackageResponse.fromJS(item));
      }
      if (Array.isArray(_data["medias"])) {
        this.medias = [] as any;
        for (let item of _data["medias"])
          this.medias!.push(ProposalMediaResponse.fromJS(item));
      }
      this.customerAccepted = _data["customerAccepted"];
    }
  }

  static fromJS(data: any): ProposalItemResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    data["priorityId"] = this.priorityId;
    data["price"] = this.price;
    data["requiredTime"] = this.requiredTime;
    data["latestResponseTime"] = this.latestResponseTime
      ? this.latestResponseTime.toISOString()
      : <any>undefined;
    if (Array.isArray(this.packages)) {
      data["packages"] = [];
      for (let item of this.packages) data["packages"].push(item.toJSON());
    }
    if (Array.isArray(this.medias)) {
      data["medias"] = [];
      for (let item of this.medias) data["medias"].push(item.toJSON());
    }
    data["customerAccepted"] = this.customerAccepted;
    return data;
  }
}

export interface IProposalItemResponse {
  id: number;
  name?: string | undefined;
  description?: string | undefined;
  priorityId?: number | undefined;
  price: number;
  requiredTime: number;
  latestResponseTime?: Date | undefined;
  packages: ProposalMediaPackageResponse[];
  medias: ProposalMediaResponse[];
  customerAccepted?: boolean | undefined;
}

export class ProposalMediaPackageRequest
  implements IProposalMediaPackageRequest
{
  id?: number | undefined;
  price?: number;
  externalPackageId?: string | undefined;

  constructor(data?: IProposalMediaPackageRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.price = _data["price"];
      this.externalPackageId = _data["externalPackageId"];
    }
  }

  static fromJS(data: any): ProposalMediaPackageRequest {
    data = typeof data === "object" ? data : {};
    let result = new ProposalMediaPackageRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["price"] = this.price;
    data["externalPackageId"] = this.externalPackageId;
    return data;
  }
}

export interface IProposalMediaPackageRequest {
  id?: number | undefined;
  price?: number;
  externalPackageId?: string | undefined;
}

export class ProposalMediaPackageResponse
  implements IProposalMediaPackageResponse
{
  id?: number | undefined;
  price!: number;
  externalPackageId!: string;

  constructor(data?: IProposalMediaPackageResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.price = _data["price"];
      this.externalPackageId = _data["externalPackageId"];
    }
  }

  static fromJS(data: any): ProposalMediaPackageResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalMediaPackageResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["price"] = this.price;
    data["externalPackageId"] = this.externalPackageId;
    return data;
  }
}

export interface IProposalMediaPackageResponse {
  id?: number | undefined;
  price: number;
  externalPackageId: string;
}

export class ProposalMediaRequest implements IProposalMediaRequest {
  id?: number | undefined;
  mediaType?: ProposalMediaTypeEnum;
  mediaUrl?: string | undefined;
  priorityAsc?: number;

  constructor(data?: IProposalMediaRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.mediaType = _data["mediaType"];
      this.mediaUrl = _data["mediaUrl"];
      this.priorityAsc = _data["priorityAsc"];
    }
  }

  static fromJS(data: any): ProposalMediaRequest {
    data = typeof data === "object" ? data : {};
    let result = new ProposalMediaRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["mediaType"] = this.mediaType;
    data["mediaUrl"] = this.mediaUrl;
    data["priorityAsc"] = this.priorityAsc;
    return data;
  }
}

export interface IProposalMediaRequest {
  id?: number | undefined;
  mediaType?: ProposalMediaTypeEnum;
  mediaUrl?: string | undefined;
  priorityAsc?: number;
}

export class ProposalMediaResponse implements IProposalMediaResponse {
  id?: number | undefined;
  mediaType!: ProposalMediaTypeEnum;
  mediaUrl?: string | undefined;
  priorityAsc?: number;

  constructor(data?: IProposalMediaResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.mediaType = _data["mediaType"];
      this.mediaUrl = _data["mediaUrl"];
      this.priorityAsc = _data["priorityAsc"];
    }
  }

  static fromJS(data: any): ProposalMediaResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalMediaResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["mediaType"] = this.mediaType;
    data["mediaUrl"] = this.mediaUrl;
    data["priorityAsc"] = this.priorityAsc;
    return data;
  }
}

export interface IProposalMediaResponse {
  id?: number | undefined;
  mediaType: ProposalMediaTypeEnum;
  mediaUrl?: string | undefined;
  priorityAsc?: number;
}

export enum ProposalMediaTypeEnum {
  Video = "Video",
  Image = "Image",
  Note = "Note",
}

export class ProposalResponse implements IProposalResponse {
  id!: string;
  status!: ProposalStatusEnum;
  created!: Date;
  updated!: Date;
  createdById!: string;
  reviewerId?: string | undefined;
  dealerNumber!: string;
  workOrderId?: string | undefined;
  businessProposalId?: string | undefined;
  proposalItems!: ProposalItemResponse[];
  proposalStatusHistories!: ProposalStatusHistoryResponse[];
  proposalVehicle!: ProposalVehicleResponse;
  proposalCustomer?: ProposalCustomerResponse;

  constructor(data?: IProposalResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.proposalItems = [];
      this.proposalStatusHistories = [];
      this.proposalVehicle = new ProposalVehicleResponse();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.status = _data["status"];
      this.created = _data["created"]
        ? new Date(_data["created"].toString())
        : <any>undefined;
      this.updated = _data["updated"]
        ? new Date(_data["updated"].toString())
        : <any>undefined;
      this.createdById = _data["createdById"];
      this.reviewerId = _data["reviewerId"];
      this.dealerNumber = _data["dealerNumber"];
      this.workOrderId = _data["workOrderId"];
      this.businessProposalId = _data["businessProposalId"];
      if (Array.isArray(_data["proposalItems"])) {
        this.proposalItems = [] as any;
        for (let item of _data["proposalItems"])
          this.proposalItems!.push(ProposalItemResponse.fromJS(item));
      }
      if (Array.isArray(_data["proposalStatusHistories"])) {
        this.proposalStatusHistories = [] as any;
        for (let item of _data["proposalStatusHistories"])
          this.proposalStatusHistories!.push(
            ProposalStatusHistoryResponse.fromJS(item)
          );
      }
      this.proposalVehicle = _data["proposalVehicle"]
        ? ProposalVehicleResponse.fromJS(_data["proposalVehicle"])
        : new ProposalVehicleResponse();
      this.proposalCustomer = _data["proposalCustomer"]
        ? ProposalCustomerResponse.fromJS(_data["proposalCustomer"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ProposalResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["status"] = this.status;
    data["created"] = this.created
      ? this.created.toISOString()
      : <any>undefined;
    data["updated"] = this.updated
      ? this.updated.toISOString()
      : <any>undefined;
    data["createdById"] = this.createdById;
    data["reviewerId"] = this.reviewerId;
    data["dealerNumber"] = this.dealerNumber;
    data["workOrderId"] = this.workOrderId;
    data["businessProposalId"] = this.businessProposalId;
    if (Array.isArray(this.proposalItems)) {
      data["proposalItems"] = [];
      for (let item of this.proposalItems)
        data["proposalItems"].push(item.toJSON());
    }
    if (Array.isArray(this.proposalStatusHistories)) {
      data["proposalStatusHistories"] = [];
      for (let item of this.proposalStatusHistories)
        data["proposalStatusHistories"].push(item.toJSON());
    }
    data["proposalVehicle"] = this.proposalVehicle
      ? this.proposalVehicle.toJSON()
      : <any>undefined;
    data["proposalCustomer"] = this.proposalCustomer
      ? this.proposalCustomer.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IProposalResponse {
  id: string;
  status: ProposalStatusEnum;
  created: Date;
  updated: Date;
  createdById: string;
  reviewerId?: string | undefined;
  dealerNumber: string;
  workOrderId?: string | undefined;
  businessProposalId?: string | undefined;
  proposalItems: ProposalItemResponse[];
  proposalStatusHistories: ProposalStatusHistoryResponse[];
  proposalVehicle: ProposalVehicleResponse;
  proposalCustomer?: ProposalCustomerResponse;
}

export enum ProposalStatusEnum {
  New = "New",
  UnderReview = "UnderReview",
  Reviewed = "Reviewed",
  Sent = "Sent",
  Opened = "Opened",
  Contacted = "Contacted",
  CustomerApproved = "CustomerApproved",
  CustomerRejected = "CustomerRejected",
  Closed = "Closed",
  ClosedWithSale = "ClosedWithSale",
}

export class ProposalStatusHistoryResponse
  implements IProposalStatusHistoryResponse
{
  id!: number;
  timestamp!: Date;
  proposalId!: string;
  status!: ProposalStatusEnum;

  constructor(data?: IProposalStatusHistoryResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.timestamp = _data["timestamp"]
        ? new Date(_data["timestamp"].toString())
        : <any>undefined;
      this.proposalId = _data["proposalId"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): ProposalStatusHistoryResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalStatusHistoryResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["timestamp"] = this.timestamp
      ? this.timestamp.toISOString()
      : <any>undefined;
    data["proposalId"] = this.proposalId;
    data["status"] = this.status;
    return data;
  }
}

export interface IProposalStatusHistoryResponse {
  id: number;
  timestamp: Date;
  proposalId: string;
  status: ProposalStatusEnum;
}

export class ProposalVehicleResponse implements IProposalVehicleResponse {
  id!: number;
  chassi!: string;
  registrationNumber!: string;
  modelText!: string;
  brand!: BrandCodeEnum;

  constructor(data?: IProposalVehicleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.chassi = _data["chassi"];
      this.registrationNumber = _data["registrationNumber"];
      this.modelText = _data["modelText"];
      this.brand = _data["brand"];
    }
  }

  static fromJS(data: any): ProposalVehicleResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalVehicleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["chassi"] = this.chassi;
    data["registrationNumber"] = this.registrationNumber;
    data["modelText"] = this.modelText;
    data["brand"] = this.brand;
    return data;
  }
}

export interface IProposalVehicleResponse {
  id: number;
  chassi: string;
  registrationNumber: string;
  modelText: string;
  brand: BrandCodeEnum;
}

export class SendProposalRequest implements ISendProposalRequest {
  proposalId!: string;
  reviewerId!: string;

  constructor(data?: ISendProposalRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.proposalId = _data["proposalId"];
      this.reviewerId = _data["reviewerId"];
    }
  }

  static fromJS(data: any): SendProposalRequest {
    data = typeof data === "object" ? data : {};
    let result = new SendProposalRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["proposalId"] = this.proposalId;
    data["reviewerId"] = this.reviewerId;
    return data;
  }
}

export interface ISendProposalRequest {
  proposalId: string;
  reviewerId: string;
}

export class UpdateProposalRequest implements IUpdateProposalRequest {
  id!: string;
  status!: ProposalStatusEnum;
  reviewerId?: string | undefined;
  workOrderId?: string | undefined;
  businessProposalId?: string | undefined;
  proposalItems?: ProposalItemRequest[] | undefined;
  proposalCustomer!: ProposalCustomerRequest;

  constructor(data?: IUpdateProposalRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.proposalCustomer = new ProposalCustomerRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.status = _data["status"];
      this.reviewerId = _data["reviewerId"];
      this.workOrderId = _data["workOrderId"];
      this.businessProposalId = _data["businessProposalId"];
      if (Array.isArray(_data["proposalItems"])) {
        this.proposalItems = [] as any;
        for (let item of _data["proposalItems"])
          this.proposalItems!.push(ProposalItemRequest.fromJS(item));
      }
      this.proposalCustomer = _data["proposalCustomer"]
        ? ProposalCustomerRequest.fromJS(_data["proposalCustomer"])
        : new ProposalCustomerRequest();
    }
  }

  static fromJS(data: any): UpdateProposalRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateProposalRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["status"] = this.status;
    data["reviewerId"] = this.reviewerId;
    data["workOrderId"] = this.workOrderId;
    data["businessProposalId"] = this.businessProposalId;
    if (Array.isArray(this.proposalItems)) {
      data["proposalItems"] = [];
      for (let item of this.proposalItems)
        data["proposalItems"].push(item.toJSON());
    }
    data["proposalCustomer"] = this.proposalCustomer
      ? this.proposalCustomer.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IUpdateProposalRequest {
  id: string;
  status: ProposalStatusEnum;
  reviewerId?: string | undefined;
  workOrderId?: string | undefined;
  businessProposalId?: string | undefined;
  proposalItems?: ProposalItemRequest[] | undefined;
  proposalCustomer: ProposalCustomerRequest;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new SwaggerException(message, status, response, headers, null);
}
